import {ENVIRONMENT_DEVARANA, UI_ID_PANEL10_RESTYPE, UI_ID_PANEL14_RESSUBTYPE, UI_ID_PANEL17_PEOPLE, UI_ID_PANEL20_CALENDAR, UI_ID_PANEL30_TIME, UI_ID_PANEL40_PACKAGEDEAL, UI_ID_PANEL50_TREATMENTS, UI_ID_PANEL60_FORM, UI_ID_PANEL70_PAY} from "../../AppConstants";

// dit is wat er altijd in de broncode van de reserveerpagina stond - geen reactivity dus niet gewrapped in $state

export let page_json = {
  data: null
};

export let progress_form_booking = {
  form: false
};

export let progress_form_login = {
  form: false
};

export let progress_form_payment = {
  form: false
};

export const progress = $state({
  bIsLocal: false, // hier op false laten staan.. wordt vanzelf gedetecteerd
  bWasReceiptLarge: false,
  sNextButtonState: 'hidden',
  bIsBookingTypeChosen: false,
  bIsRestaurantTunerOpen: false,
  oTimeSlotPopup: {
    bIsOpen: false,
    iProductID: false,
    oPerson: false,
    aAvailableSlots: false
  },
  sCalendarInfo: false,
  sBlockedDayMessage: false, // toelichting bij een NIET-boekbare dag (klik/tik/hover), onder de kalender
  bShowServiceMessage: false,
  sServiceMessageColor: false,
  sServiceMessageContent: false,
  iSubmitToServerCounter: 1,
  bWasSubmittedToServer: false,
  bWasRedirectedToPaymentProviderBeforeNow: false,
  bThereWasAPreselectedPackageDealButItIsNotAvailable: false,
  bThereWasAPreselectedTreatmentButItIsNotAvailable: false,
  bShowMessageThereWasAPreselectedTreatmentButItIsNotAvailable: false,
  sServerFeedbackAfterSubmission: false,
  bShowNoticeInRightPanel: false,
  bIsDialogOpen: false,
  bIsReceiptReadyToBeVisible: false,
  bIsReceiptInEditMode: false,
  sDialogTitle: '',
  sDialogContent: '',
  bIsReceiptDialogOpen: false,
  //sLastActiveProductCatTab: false,
  bIsProductDialogOpen: false,
  iProductDialogProductID: 0,
  iProductDialogProductSetID: 0,
  // Add-sidebar voor élke Sweetlake buyable (los product = set van één, anchor+variant
  // = set van twee). Per-gast secties met variant-cards; de gast voegt elke variant
  // expliciet toe (geen auto-add). Houdt zijn eigen open-flag + lijst van product-IDs +
  // door de backend geleverde combined duration label (bv. "25 of 50 min."). Los van de
  // info-modal (bIsProductDialogOpen) zodat beide onafhankelijk kunnen evolueren.
  bIsProductsetAddSidebarOpen: false,
  iProductsetAddSidebarProductSetID: 0,
  aProductsetAddSidebarProductIDs: [],
  sProductsetAddSidebarDurationLabel: '',
  // Add/edit-sidebar voor multi-person behandelingen ("koppelbehandelingen"): eigen open-flag +
  // de product-IDs van de set + het duration label. De sidebar (sidebar-productset-together.svelte)
  // beheert zelf de stappen (product -> gasten -> tijd). Los van de gewone productset-sidebar.
  bIsProductsetTogetherSidebarOpen: false,
  iProductsetTogetherSidebarProductSetID: 0,
  aProductsetTogetherSidebarProductIDs: [],
  sProductsetTogetherSidebarDurationLabel: '',
  // Add-sidebar voor een Sweetlake arrangement (package deal). Mirror van de productset
  // add-sidebar hierboven: eigen open-flag + het ID van het arrangement dat in de sidebar
  // wordt getoond/bewerkt. De inbegrepen producten + de per-gast keuzes worden in de
  // sidebar zelf gerenderd (zie packagedeal-sidebar-add.svelte). Los van de info-modal
  // (bIsPackageDealDialogOpen) zodat beide onafhankelijk kunnen evolueren.
  bIsPackageDealAddSidebarOpen: false,
  iPackageDealAddSidebarID: 0,
  // Bevestig-overlay voor het verwijderen van een arrangement vanuit de bon. Arrangementen
  // gelden voor álle gasten; bij een boeking met meerdere bezoekers vragen we eerst om
  // bevestiging (zie overlay-confirm-packagedeal-delete.svelte) voordat we daadwerkelijk
  // verwijderen. Houdt het te verwijderen arrangement-ID vast tot bevestiging/annulering.
  bShowPackageDealDeleteConfirmOverlay: false,
  iPackageDealDeleteConfirmID: 0,
  bIsPackageDealDialogOpen: false,
  iPackageDialogPackageDealID: 0,
  bWasJSONDataFromPageReceived: false,
  bWasJSONDataFromPageParsed: false,
  bWasWidgetsSharedBootSequenceStarted: false,
  bWasBaseJSONForWidgetsReceived: false,
  bWasBaseJSONForWidgetsParsed: false,
  aCalendarDates: [],
  oValidationReport: {
    aAllowedSteps: [10],
    aIncorrectFields: {
      [UI_ID_PANEL10_RESTYPE]: [],
      [UI_ID_PANEL14_RESSUBTYPE]: [],
      [UI_ID_PANEL17_PEOPLE]: [],
      [UI_ID_PANEL20_CALENDAR]: [],
      [UI_ID_PANEL30_TIME]: [],
      [UI_ID_PANEL40_PACKAGEDEAL]: [],
      [UI_ID_PANEL50_TREATMENTS]: [],
      [UI_ID_PANEL60_FORM]: [],
      [UI_ID_PANEL70_PAY]: []
    }
  },
  sEnvironmentID: 'ENVIRONMENT_DEVARANA',
  bIsEnvDevarana: true,
  bIsEnvDenIlp: false,
  bIsEnvRidderrode: false,
  bIsEnvSweetLake: false,
  dog: null,

  sImageURLMain: '',
  sImageURLProduct: '',
  sImageURLPackageDeal: '',

  sFetchCustomerAPIEndpoint: '', // nog gebruikt?
  sURLPassword: '',
  sURLPrivacy: '',
  sURLHouseholdRules: '',
  sURLInsurance: '',
  bHideNextButton: false,
  bIsLoginScreenActive: false,
  bIsDebugModeEnabled: false,
  bIsFetchingDog: false,
  bIsFetchingTreatments: false,
  bIsFetchingPackageDeals: false,
  bIsFetchingLogin: false,
  bIsFetchingCalendar: false,
  // Hierin houden we bij met welke params de kalender call het laatst is gedaan zodat we die niet dubbel doen
  oLastCalendarRequestParams: null,
  bIsFetchingRestaurant: false,
  // bIsFetchingGiftcard: false,
  sFetchingLoginError: false,
  bIsFetchingReservationFeedback: false,
  sFetchingError: false,
  aSteps: [10, 14, 17, 20, 30, 40, 50, 60, 70, 80],
  iHighestShownStep: 10,
  iHighestAttemptedStep: 10, // nodig om bij te houden voor welke stappen we validaties willen zien.. pas als iemand door heeft geprobeerd te klikken naar 20 tonen we feedback voor < 20
  iCurrentVisibleStep: 10, // omdat het mogelijk is dat je qua data invullen al een paar stappen verder bent, maar terug gaat naar een andere stap
  iLoginScreenComponentRefreshCounter: 0,
  iFormComponentRefreshCounter: 0,
  bIsFetchingGiftCardValue: false,
  bIsFetchingBadenkaartValue: false,
  iLastSubmittedTimestamp: 0,
  iLastSubmittedBookingUpdateCounter: 0,

  // Overlay die in beeld komt als de gebruiker een product of packagedeal wil toevoegen aan de cart terwijl de availability call nog bezig is
  bShowAvailabilityPendingOverlay: false,

  // Brand gate: server-side controlled via BRAND_GATE_ENABLED env var
  bShowGate: false
});

window.hmk_progress = () => {
  console.log($state.snapshot(progress));
}

window.hmk_page_JSON = () => {
  console.log(page_json);
}
